module.exports = __webpack_public_path__ + "mq.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mq.svg
// module id = 956
// module chunks = 0